var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"wave",rawName:"v-wave",value:({color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}),expression:"{color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}"}],class:{ active: _vm.isActive, inactive: _vm.isInactive },on:{"click":_vm.toggle}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e23765b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfiguratorStepExtrasItem.vue
// module id = null
// module chunks = 